import { FC, Fragment, useState } from "react";
import Button from "./bootstrap/Button"
import Dropdown, { DropdownToggle, DropdownMenu, DropdownItem } from "./bootstrap/Dropdown"
import Spinner from "./bootstrap/Spinner";
import classNames from 'classnames';

interface StatusDropdownProps {
    itemId: string;
    status: boolean;
    change: (id: string, status: boolean, toggleStatus: Function) => void;
    disabled?: boolean;
    className?: string;
}

const StatusDropdown: FC<StatusDropdownProps> = ({itemId, status, change, disabled=false, className}) => {

    const [isActive, setIsActive] = useState<boolean>(status);

    const toggleState = (newStatus: boolean) => {
        change(itemId, newStatus, setIsActive);
    }
   
    return (
        <Dropdown>
            <DropdownToggle hasIcon={false}>
                <Button isLink isDisable={disabled} color={isActive ? 'success' : 'danger'} icon='Circle' className={classNames('text-nowrap', className)}> 
                    {disabled ? <Spinner isSmall/> : <Fragment> {isActive ? 'Activado' : 'Desactivado'}  </Fragment>}
                </Button>
            </DropdownToggle>
            <DropdownMenu>
                    <DropdownItem>
                        <Button isLink onClick={()=>toggleState(!isActive)} color={isActive ? 'danger' : 'success'} icon='Circle' className={classNames('text-nowrap', className)}> {isActive ? 'Desactivado' : 'Activado'} </Button>
                    </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    )
}

export default StatusDropdown;

